// O totem desenha cada foto descomprimida no editor (largura × altura × 4
// bytes). Uma foto de celular de 12 MP ocupa ~48 MB na memória do totem, e
// com 4 fotos o navegador do totem chegava a desenhar a foto em branco.
//
// A maior folha impressa precisa de 1774 px no lado em que a foto é
// encaixada (foto deitada numa folha em pé). Com o lado menor em 2048 px
// a foto cobre a folha sem ampliar e ainda sobra margem para o zoom no editor.
export const LADO_MENOR_MAXIMO = 2048;
export const LADO_MAIOR_MAXIMO = 4096;
const QUALIDADE_JPEG = 0.92;

// Dimensões finais mantendo a proporção. Nunca amplia.
export function calcularDimensoes(largura, altura) {
  const menor = Math.min(largura, altura);
  const maior = Math.max(largura, altura);
  const escala = Math.min(
    1,
    LADO_MENOR_MAXIMO / menor,
    LADO_MAIOR_MAXIMO / maior
  );
  return {
    largura: Math.round(largura * escala),
    altura: Math.round(altura * escala),
    reduzir: escala < 1,
  };
}

function lerComoDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

function carregarImagem(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("imagem_nao_decodificada"));
    img.src = src;
  });
}

// Devolve o data URL da foto pronta para envio: reduzida (JPEG) quando passa
// do limite, ou o arquivo original quando já é pequena. Se o navegador não
// conseguir reduzir (formato que ele não decodifica, falta de memória),
// envia o original como antes.
export async function reduzirFoto(file) {
  const objectUrl = URL.createObjectURL(file);
  try {
    const img = await carregarImagem(objectUrl);
    // O navegador já aplica a rotação do EXIF em naturalWidth/naturalHeight e
    // no drawImage, então a foto reduzida sai em pé (e sem o EXIF).
    const { largura, altura, reduzir } = calcularDimensoes(
      img.naturalWidth || img.width,
      img.naturalHeight || img.height
    );
    if (!reduzir) return await lerComoDataUrl(file);

    const canvas = document.createElement("canvas");
    canvas.width = largura;
    canvas.height = altura;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("canvas_sem_contexto");
    // PNG com transparência viraria fundo preto no JPEG.
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, largura, altura);
    ctx.drawImage(img, 0, 0, largura, altura);
    const dataUrl = canvas.toDataURL("image/jpeg", QUALIDADE_JPEG);
    // Sem memória o navegador devolve "data:," em vez de lançar erro.
    if (!dataUrl || !dataUrl.startsWith("data:image/jpeg")) {
      throw new Error("exportacao_vazia");
    }
    return dataUrl;
  } catch (error) {
    console.warn("Não foi possível reduzir a foto, enviando original", error);
    return lerComoDataUrl(file);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
